module.exports = __webpack_public_path__ + "static/img/baiDu.22d565e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/baiDu.svg
// module id = kB5O
// module chunks = 1